<template>
  <div>
    <action-bar>
        <router-link to="/online-factor-format-create" class="btn btn-success">{{ 'ایجاد قالب' }}</router-link>
    </action-bar>
    <filter_format :action="filterAction"/>
    <format-with-manage v-if="$can('change-setting', 'payment-link')" ref="datatable" :query="query" />
    <format-without-manage v-else ref="datatable" :query="query" />
  </div>
</template>

<script>
import FormatWithManage from "@/views/online-factor/format-with-manage.vue";
import Filter_format from "@/views/online-factor/components/filter_format.vue";
import FormatWithoutManage from "@/views/online-factor/format-without-manage.vue";
import actionBar from "@/components/custom/action-bar.vue";

export default {
  name: "formats",
  components: {
      'action-bar': actionBar,
      FormatWithoutManage,
      Filter_format,
      FormatWithManage
  },
  data() {
    return {
      query: {}
    };
  },
  methods: {
    filterAction(e, query) {
      this.query = query;
      if (this.$refs.datatable && this.$refs.datatable.$refs.datatable) {
        this.$refs.datatable.$refs.datatable.reload();
      }
    }
  }
}
</script>

<style scoped>

</style>